export default __webpack_public_path__ + "images/2520bc117b9d962f4a692ba041bb8ab5-race.jpg";